import { globalConstants, centerInstructorsConstants } from "../../constants";

const initialState = {
  instrctorDetails: null,
  centerInstructorsData: { page: {}, pageData: [] },
  centerInstructorDetails: null,
  isHeadInstructorModal: false,
};

const {
  GET_INSTRUCTOR_BY_EMAIL,
  GET_CENTER_INSTRUCTORS,
  GET_CENTER_INSTRUCTOR_DETAIL_BY_ID,
  RESET_INSTRUCTOR_DETAILS,
  OPEN_HEAD_INSTRUCTOR_MODAL,
} = centerInstructorsConstants;

const centerInstructorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INSTRUCTOR_BY_EMAIL + globalConstants.SUCCESS:
      return {
        ...state,
        instrctorDetails: action.data,
      };
    case GET_INSTRUCTOR_BY_EMAIL + globalConstants.FAILURE:
      return {
        ...state,
        instrctorDetails: null,
      };
    case GET_CENTER_INSTRUCTORS + globalConstants.SUCCESS:
      return {
        ...state,
        centerInstructorsData: action.data,
      };
    case GET_CENTER_INSTRUCTOR_DETAIL_BY_ID + globalConstants.SUCCESS:
      return {
        ...state,
        centerInstructorDetails: action.data,
      };
    case GET_CENTER_INSTRUCTOR_DETAIL_BY_ID + globalConstants.FAILURE:
      return {
        ...state,
        centerInstructorDetails: null,
      };
    case RESET_INSTRUCTOR_DETAILS + globalConstants.SUCCESS:
      return {
        ...state,
        instrctorDetails: null,
      };
    case OPEN_HEAD_INSTRUCTOR_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        isHeadInstructorModal: action.data,
      };
    default:
      return state;
  }
};

export default centerInstructorsReducer;
